// import React, { useState, useEffect, useRef } from "react";
// import {
//   Form,
//   DatePicker,
//   Select,
//   Button,
//   Table,
//   message,
//   Tabs,
//   Typography,
//   Input,
// } from "antd";
// import moment from "moment";
// import { API, Headers } from "../../Config";
// import axios from "axios";
// import ReactToPrint from "react-to-print";
// import { PrinterOutlined } from "@ant-design/icons";
// const { TabPane } = Tabs;
// const { Text } = Typography;
// const { RangePicker } = DatePicker;
// const { Option } = Select;

// const AwbReports = () => {
//   const [loading, setLoading] = useState(false);
//   const componentRef = useRef();
//   const [form] = Form.useForm();
//   const [filteredDataSource, setFilteredDataSource] = useState([]);
//   const [dateRange, setDateRange] = useState([]);

//   const onFinish = async (values) => {
//     const { dateRange, awb_no } = values;

//     setLoading(true);
//     let obj = {};

//     if (dateRange && dateRange.length === 2) {
//       const [startDate, endDate] = dateRange;
//       const formattedStartDate = startDate
//         ? startDate.startOf("day").toISOString()
//         : null;
//       const formattedEndDate = endDate
//         ? endDate.endOf("day").toISOString()
//         : null;

//       obj = {
//         date_from: formattedStartDate,
//         date_to: formattedEndDate,
//       };
//     } else if (awb_no) {
//       obj = {
//         awb_no: awb_no,
//       };
//     }

//     axios({
//       method: "post",
//       url: API.BASR_URL + API.AWB_PAYMENT_ACTIONS + `awbReport`,
//       headers: Headers(),
//       data: obj,
//     })
//       .then(function (response) {
//         setLoading(false);
//         if ([200, 201].includes(response.status)) {
//           message.success("Success");

//           setFilteredDataSource(response?.data?.data);
//         }
//       })
//       .catch(function (error) {
//         setLoading(false);
//         message.error("Oops. Something went wrong");
//         console.log(error);
//       });
//   };

//   const columns = [
//     {
//       width: "120px",
//       title: "Date",
//       dataIndex: "date",
//       key: "date",

//       render: (text, record, index) => (
//         <div className="data-table-items">
//           {moment(record.date).format("DD-MM-YYYY")}
//         </div>
//       ),
//     },
//     Table.EXPAND_COLUMN,
//     {
//       width: "250px",
//       title: "AWB",
//       dataIndex: "description",
//       key: "description",
//     },
//     {
//       title: "Chargable Weight",
//       dataIndex: "chargable_weight",
//       key: "chargable_weight",
//     },
//     {
//       title: "origin",
//       dataIndex: "orijin",
//       key: "orijin",
//     },
//     {
//       title: "destination",
//       dataIndex: "destination",
//       key: "destination",
//     },

//     {
//       title: "Bound",
//       dataIndex: "bound",
//       key: "bound",
//     },

//     {
//       title: "Income",
//       dataIndex: "box_charge",
//       key: "box_charge",
//       render: (text, record, index) => (
//         <div className="data-table-items">
//           {Number(record.box_charge).toFixed(2)}
//         </div>
//       ),
//     },
//     {
//       title: "Expence",
//       dataIndex: "amount",
//       key: "amount",
//       render: (text, record, index) => (
//         <div className="data-table-items">
//           {Number(record.amount).toFixed(2)}
//         </div>
//       ),
//     },
//     {
//       title: "Profit",
//       dataIndex: "balance",
//       key: "balance",
//       render: (text, record, index) => (
//         <div className="data-table-items">
//           {Number(record.balance).toFixed(2)}
//         </div>
//       ),
//     },
//   ];

//   const renderSummary = () => {
//     const totalDrAmount = filteredDataSource?.reduce((acc, item) => {
//       if (item.dr_or_cr === "Dr") {
//         return acc + item?.amount;
//       }
//       return acc;
//     }, 0);
//     const totalCrAmount = filteredDataSource?.reduce((acc, item) => {
//       if (item.dr_or_cr === "Cr") {
//         return acc + item?.amount;
//       }
//       return acc;
//     }, 0);

//     return (
//       <>
//         <Table.Summary.Row className="my-summary-row">
//           <Table.Summary.Cell className="cell"></Table.Summary.Cell>
//           <Table.Summary.Cell className="cell"></Table.Summary.Cell>
//           <Table.Summary.Cell className="cell"></Table.Summary.Cell>
//           <Table.Summary.Cell className="cell">
//             {" "}
//             <b>Total</b>
//           </Table.Summary.Cell>

//           <Table.Summary.Cell className="cell">
//             {" "}
//             <b style={{ paddingLeft: "9px" }}>
//               {Number(totalDrAmount).toFixed(2)}
//             </b>
//           </Table.Summary.Cell>
//           <Table.Summary.Cell className="cell">
//             {" "}
//             <b style={{ paddingLeft: "9px" }}>
//               {Number(totalCrAmount).toFixed(2)}
//             </b>
//           </Table.Summary.Cell>
//           <Table.Summary.Cell className="cell">
//             {" "}
//             <b style={{ paddingLeft: "9px" }}>
//               {(Number(totalDrAmount) - Number(totalCrAmount)).toFixed(2)}
//             </b>
//           </Table.Summary.Cell>
//         </Table.Summary.Row>
//       </>
//     );
//   };

//   const expandedRowRender = (record) => {
//     const columns = [
//       {
//         title: "#",
//         key: "index",
//         width: "20px",
//         render: (text, record, index) => index + 1,
//       },
//       {
//         title: "Box No",
//         dataIndex: "box_number",
//         key: "box_number",
//       },
//       {
//         title: "Chargable Weight",
//         dataIndex: "chargable_weight",
//         key: "chargable_weight",
//       },
//       {
//         title: "Total Charge",
//         dataIndex: "totalCharge",
//         key: "totalCharge",
//       },

//       {
//         title: "Discount",
//         dataIndex: "totalDiscount",
//         key: "totalDiscount",
//       },
//       {
//         title: "Paid Amount",
//         dataIndex: "boxPaidCash",
//         key: "boxPaidCash",
//       },
//       {
//         title: "Outanding Amount",
//         dataIndex: "balance",
//         key: "balance",
//       },
//     ];
//     const columpayment = [
//       {
//         title: "#",
//         key: "index",
//         width: "20px",
//         render: (text, record, index) => index + 1,
//       },

//       {
//         title: "Account No",
//         dataIndex: "",
//         key: "",
//         render: (text) => {
//           return (
//             <div>
//               {text?.accounts?.account_name} - {text?.accounts?.account_no}
//             </div>
//           );
//         },
//       },
//       { title: "Description", dataIndex: "description", key: "description" },

//       { title: "Amount", dataIndex: "amount", key: "amount" },
//     ];

//     // Replace with your desired target date in the same format as the "invoice_date"

//     const paymentSummery = (record) => {
//       let amount = 0;
//       let debitTotal = 0;
//       record.forEach((value) => {
//         amount += value.amount;
//       });
//       return (
//         <Table.Summary fixed>
//           <Table.Summary.Row>
//             <Table.Summary.Cell></Table.Summary.Cell>
//             <Table.Summary.Cell align="right">
//               <b>Total</b>
//             </Table.Summary.Cell>
//             <Table.Summary.Cell align="center">
//               {/* <Text type="danger">{Number(creditTotal).toFixed(2)}</Text> */}
//             </Table.Summary.Cell>
//             <Table.Summary.Cell align="center">
//               <Text type="danger">{Number(amount).toFixed(2)}</Text>
//             </Table.Summary.Cell>
//             <Table.Summary.Cell></Table.Summary.Cell>
//           </Table.Summary.Row>
//         </Table.Summary>
//       );
//     };

//     return (
//       <Tabs onChange={(e) => {}} tabPosition="left" style={{ margin: "10px" }}>
//         <TabPane tab="Items Details" key="tab1">
//           <div
//             style={{
//               background: "white",
//               padding: "10px",
//               borderRadius: "5px",
//             }}
//           >
//             <h5>Items Details</h5>
//             <p>Total box and details..</p>
//             <Table
//               className="table_item"
//               style={{
//                 padding: "20px",
//               }}
//               bordered
//               size="small"
//               columns={columns}
//               dataSource={record?.boxes}
//               pagination={false}
//             />
//           </div>
//         </TabPane>

//         <TabPane tab="Payment Details" key="tab2">
//           <div
//             style={{
//               background: "white",
//               padding: "10px",
//               borderRadius: "5px",
//             }}
//           >
//             <h5>Payment Details</h5>
//             <p>All payment details</p>
//             <Table
//               className="table_item"
//               style={{
//                 padding: "20px",
//               }}
//               bordered
//               size="small"
//               columns={columpayment}
//               dataSource={record?.payment}
//               summary={paymentSummery}
//               pagination={false}
//             />
//           </div>
//         </TabPane>
//       </Tabs>
//     );
//   };
//   return (
//     <div>
//       <Form
//         form={form}
//         layout="inline"
//         onFinish={onFinish}
//         style={{
//           marginBottom: 16,
//           display: "flex",
//           justifyContent: "center",
//           border: "1px solid #ccc",
//           padding: "16px",
//         }}
//       >
//         <Form.Item name="dateRange">
//           <RangePicker size="small" style={{ width: 240 }} />
//         </Form.Item>
//         <Form.Item
//           name="awb_no"
//           label="Awb No"
//           rules={[{ required: false, message: "required" }]}
//         >
//           <Input placeholder="Enter Name" />
//         </Form.Item>
//         <Form.Item>
//           <Button
//             size="small"
//             type="primary"
//             htmlType="submit"
//             // onClick={handleSearch}
//             loading={loading}
//           >
//             Search
//           </Button>
//         </Form.Item>
//         <Form.Item>
//           <ReactToPrint
//             trigger={() => (
//               <Button
//                 size="small"
//                 type="primary"
//                 icon={<PrinterOutlined />}
//                 style={{ marginLeft: 8 }}
//               >
//                 Print
//               </Button>
//             )}
//             content={() => componentRef.current}
//           />
//         </Form.Item>
//       </Form>
//       <div ref={componentRef} style={{ margin: "20px 20px" }}>
//         <div style={{ marginBottom: "10px" }}>
//           <b>Date Range:</b> {moment(dateRange[0]).format("DD-MM-YYYY")} to{" "}
//           {moment(dateRange[1]).format("DD-MM-YYYY")}
//         </div>

//         <Table
//           dataSource={filteredDataSource}
//           columns={columns}
//           pagination={false}
//           rowKey={(record) => record?.id}
//           expandable={{ expandedRowRender, defaultExpandedRowKeys: ["0"] }}
//         />
//       </div>
//     </div>
//   );
// };

// export default AwbReports;

import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  DatePicker,
  Button,
  Table,
  message,
  Tabs,
  Typography,
  Input,
  Modal,
} from "antd";
import moment from "moment";
import { API, Headers } from "../../Config";
import axios from "axios";
import ReactToPrint from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import PageHeader from "../../Routes/PageHeader";

const { TabPane } = Tabs;
const { Text } = Typography;
const { RangePicker } = DatePicker;

const AwbReports = () => {
  const [loading, setLoading] = useState(false);
  const componentRef = useRef();
  const [form] = Form.useForm();
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const [dateRange, setDateRange] = useState([]);

  const onFinish = async (values) => {
    const { dateRange, awb_no } = values;
    setLoading(true);

    const obj = {};
    if (dateRange && dateRange.length === 2) {
      const [startDate, endDate] = dateRange;
      obj.date_from = startDate ? startDate.startOf("day").toISOString() : null;
      obj.date_to = endDate ? endDate.endOf("day").toISOString() : null;
      setDateRange([startDate, endDate]);
    }
    if (awb_no) {
      obj.awb_no = awb_no;
    }

    try {
      const response = await axios.post(
        `${API.BASR_URL}${API.AWB_PAYMENT_ACTIONS}awbReport`,
        obj,
        { headers: Headers() }
      );

      setLoading(false);
      if ([200, 201].includes(response.status)) {
        message.success("Success");
        setFilteredDataSource(response?.data?.data || []);
        if (!response?.data?.data?.length) {
          setShowWarning(true);
        }
      }
    } catch (error) {
      setLoading(false);
      message.error("Oops. Something went wrong");
      console.error(error);
    }
  };

  const handleCancel = () => {
    setShowWarning(false);
  };

  const columns = [
    {
      width: "120px",
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text) => (
        <div className="data-table-items">
          {moment(text).format("DD-MM-YYYY")}
        </div>
      ),
    },
    Table.EXPAND_COLUMN,
    {
      width: "250px",
      title: "AWB",
      dataIndex: "awb_no",
      key: "awb_no",
    },
    {
      // width: "250px",
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Chargable Weight",
      dataIndex: "chargable_weight",
      key: "chargable_weight",
    },
    {
      title: "Origin",
      dataIndex: "orijin",
      key: "orijin",
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "destination",
    },
    {
      title: "Bound",
      dataIndex: "bound",
      key: "bound",
    },
    {
      title: "Income",
      dataIndex: "box_charge",
      key: "box_charge",
      render: (text) => (
        <div className="data-table-items">{Number(text).toFixed(2)}</div>
      ),
    },
    {
      title: "Expense",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <div className="data-table-items">{Number(text).toFixed(2)}</div>
      ),
    },
    // {
    //   title: "Profit",
    //   dataIndex: "balance",
    //   key: "balance",
    //   render: (text) => (
    //     <div className="data-table-items">{Number(text).toFixed(2)}</div>
    //   ),
    // },
    {
      title: "Profit",
      key: "balance",
      render: (_, record) => {
        const income = Number(record?.box_charge) || 0;
        const expense = Number(record?.amount) || 0;
        const profit = income - expense;
        return <div className="data-table-items">{profit?.toFixed(2)}</div>;
      },
    },
  ];

  const renderSummary = () => {
    const totalDrAmount = filteredDataSource?.reduce((acc, item) => {
      return item.dr_or_cr === "Dr" ? acc + Number(item.amount) : acc;
    }, 0);
    const totalCrAmount = filteredDataSource?.reduce((acc, item) => {
      return item.dr_or_cr === "Cr" ? acc + Number(item.amount) : acc;
    }, 0);

    return (
      <Table.Summary.Row className="my-summary-row">
        <Table.Summary.Cell />
        <Table.Summary.Cell />
        <Table.Summary.Cell />
        <Table.Summary.Cell>
          <b>Total</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          <b style={{ paddingLeft: "9px" }}>
            {Number(totalDrAmount).toFixed(2)}
          </b>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          <b style={{ paddingLeft: "9px" }}>
            {Number(totalCrAmount).toFixed(2)}
          </b>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          <b style={{ paddingLeft: "9px" }}>
            {(Number(totalDrAmount) - Number(totalCrAmount)).toFixed(2)}
          </b>
        </Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: "#",
        key: "index",
        width: "20px",
        render: (text, record, index) => index + 1,
      },
      {
        title: "Box No",
        dataIndex: "box_number",
        key: "box_number",
      },
      {
        title: "Chargable Weight",
        dataIndex: "chargable_weight",
        key: "chargable_weight",
      },
      {
        title: "Total Charge",
        dataIndex: "totalCharge",
        key: "totalCharge",
        render: (value) => (value ? Number(value)?.toFixed(2) : "0.00"),
      },
      {
        title: "Discount",
        dataIndex: "totalDiscount",
        key: "totalDiscount",
        render: (value) => (value ? Number(value)?.toFixed(2) : "0.00"),
      },
      {
        title: "Paid Amount",
        dataIndex: "boxPaidCash",
        key: "boxPaidCash",
        render: (value) => (value ? Number(value)?.toFixed(2) : "0.00"),
      },
      {
        title: "Outstanding Amount",
        dataIndex: "balance",
        key: "balance",
        render: (value) => (value ? Number(value)?.toFixed(2) : "0.00"),
      },
    ];

    const columpayment = [
      {
        title: "#",
        key: "index",
        width: "20px",
        render: (text, record, index) => index + 1,
      },
      {
        title: "Account No",
        dataIndex: "",
        key: "",
        render: (text) => (
          <div>
            {text?.accounts?.account_name} - {text?.accounts?.account_no}
          </div>
        ),
      },
      { title: "Description", dataIndex: "description", key: "description" },
      { title: "Amount", dataIndex: "amount", key: "amount" },
    ];

    const paymentSummery = (record) => {
      const totalAmount = record.reduce(
        (acc, value) => acc + Number(value.amount),
        0
      );
      return (
        <Table.Summary fixed>
          <Table.Summary.Row>
            <Table.Summary.Cell />
            <Table.Summary.Cell align="right">
              <b>Total</b>
            </Table.Summary.Cell>
            <Table.Summary.Cell />
            <Table.Summary.Cell align="center">
              <Text type="danger">{Number(totalAmount).toFixed(2)}</Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        </Table.Summary>
      );
    };

    return (
      <Tabs onChange={() => {}} tabPosition="left" style={{ margin: "10px" }}>
        <TabPane tab="Items Details" key="tab1">
          <div
            style={{
              background: "white",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <h5>Items Details</h5>
            <p>Total box and details..</p>
            <Table
              className="table_item"
              style={{ padding: "20px" }}
              bordered
              size="small"
              columns={columns}
              dataSource={record?.boxes}
              pagination={false}
            />
          </div>
        </TabPane>
        <TabPane tab="Payment Details" key="tab2">
          <div
            style={{
              background: "white",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <h5>Payment Details</h5>
            <p>All payment details</p>
            <Table
              className="table_item"
              style={{ padding: "20px" }}
              bordered
              size="small"
              columns={columpayment}
              dataSource={record?.payment}
              summary={paymentSummery}
              pagination={false}
            />
          </div>
        </TabPane>
      </Tabs>
    );
  };

  return (
    <div>
      <PageHeader
        PageName={"Awb profit report"}
        breadScrum={"Admin / AWB profit report"}
      />

      <Form
        form={form}
        layout="inline"
        onFinish={onFinish}
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Form.Item name="dateRange" label="Date Range">
          <RangePicker size="small" style={{ width: 240 }} />
        </Form.Item>
        <Form.Item name="awb_no" label="AWB No">
          <Input placeholder="Enter AWB Number" />
        </Form.Item>
        <Form.Item>
          <Button
            size="small"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Search
          </Button>
        </Form.Item>
        <Form.Item>
          <ReactToPrint
            trigger={() => (
              <Button
                size="small"
                type="primary"
                icon={<PrinterOutlined />}
                style={{ marginLeft: 8 }}
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Form.Item>
      </Form>
      <div ref={componentRef} style={{ margin: "20px 20px" }}>
        {dateRange.length === 2 && (
          <div style={{ marginBottom: "10px" }}>
            <b>Date Range:</b> {moment(dateRange[0]).format("DD-MM-YYYY")} to{" "}
            {moment(dateRange[1]).format("DD-MM-YYYY")}
          </div>
        )}
        <Table
          dataSource={filteredDataSource}
          columns={columns}
          pagination={false}
          rowKey={(record) => record?.id}
          expandable={{ expandedRowRender }}
          // summary={renderSummary}
        />
      </div>
      <Modal
        title="Warning"
        visible={showWarning}
        onCancel={handleCancel}
        onOk={handleCancel}
      >
        <p>No transactions found against these airwaybill !</p>
      </Modal>
    </div>
  );
};

export default AwbReports;
